module.exports = __webpack_public_path__ + "img/f-thermometer-img7-3.8fe9ccb1.jpg";